import * as React from 'react';
import Box from '@mui/material/Box';
import Stepper from '@mui/material/Stepper';
import Step from '@mui/material/Step';
import StepLabel from '@mui/material/StepLabel';
import StepContent from '@mui/material/StepContent';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import Agences from "../Database/Agences.json";
import { useTranslation } from 'react-i18next';


export default function StepperAgence() {
    const [activeStep, setActiveStep] = React.useState(0);

    const { t } = useTranslation();

    const handleNext = (step: number) => {
        setActiveStep(step);
    };
    return (
        <Box padding={2} borderLeft={1}>
            <Typography textAlign={"left"} variant='h6'>{t('Label.Titre.titre67')}</Typography>
            <Box height={400} overflow={"auto"} padding={3}>
                <Stepper activeStep={activeStep} orientation="vertical">
                    {Agences.map((a, index) => (
                        <Step key={a.numero}>
                            <StepLabel>
                                <Button variant='contained' style={{ boxShadow: "none", backgroundColor: "rgba(255, 164, 18, .1)", color: "black" }} fullWidth onClick={() => { handleNext(index) }}>
                                    <Typography>{a.dateCreation}</Typography>
                                </Button>
                                <hr color='orange' />
                            </StepLabel>
                            <StepContent>
                                <Box textAlign={'left'}>
                                    <Typography> Agence :</Typography>
                                    <Typography><b>{a.agence}</b></Typography>
                                    <hr />
                                    <Typography> Région :</Typography>
                                    <Typography><b>{t(a.region)}</b></Typography>
                                    <hr />
                                    <Typography> Emplacement :</Typography>
                                    <Typography><b>{a.emplacement}</b></Typography>
                                    <hr />
                                    <Typography> Téléphone :</Typography>
                                    <Typography><b>{"(+237) " + a.telephone}</b></Typography>
                                </Box>
                            </StepContent>
                        </Step>
                    ))}
                </Stepper>
            </Box>
        </Box>
    );
}
